import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import type { PrivateMoneyFormValues } from '..';
import Color from '../../../atoms/Color';
import Grid from '../../../atoms/Grid';
import Label from '../../../atoms/Label';
import Tooltip from '../../../atoms/Tooltip';

const FormGrid = styled(Grid.Container)`
  ${Label} {
    margin-bottom: 0;
    padding: 5px 0;
    font-weight: bold;
    color: #676767;
  }

  ${Grid.Divider} {
    margin: 12px 0;
  }
`;

const ColorPicker = styled(Color)`
  width: 100%;
  height: 24px;
`;

const ColorHex = styled.input.attrs({ disabled: true })`
  width: 100%;
  height: 24px;
  background-color: #eaeae4;
`;

const LabeledTooltipWrapper = styled.div`
  display: flex;
  gap: 4px;
  align-items: baseline;
`;

const DeviceInfoForm = ({
  allowedInputs = 'all',
}: {
  allowedInputs?: 'all' | (keyof PrivateMoneyFormValues)[];
}) => {
  const { control } = useFormContext<PrivateMoneyFormValues>();

  const isInputAllowed = (name: keyof PrivateMoneyFormValues) =>
    allowedInputs === 'all' || allowedInputs?.includes(name);

  return (
    <FormGrid>
      <Grid.Item size={2}>
        <LabeledTooltipWrapper>
          <Label>デバイス共通</Label>
          <Tooltip id="devices" text="ペイスポット、ペイボックス、チャージ機が対象です" />
        </LabeledTooltipWrapper>
      </Grid.Item>
      <Grid.Item size={8} container gridSize={2} columnGap={32} rowGap={8}>
        <Grid.Item flexDirection="column">
          <Label>背景色</Label>
          <Controller
            name="base_color"
            control={control}
            render={({ field: { onChange, value } }) => (
              <>
                <ColorPicker
                  onChange={onChange}
                  value={value}
                  disabled={!isInputAllowed('base_color')}
                />
                <ColorHex value={value} />
              </>
            )}
          />
        </Grid.Item>
      </Grid.Item>

      <Grid.Divider />

      <Grid.Item nextRow size={2}>
        <Label>チャージ機</Label>
      </Grid.Item>
      <Grid.Item size={8} container gridSize={2} columnGap={32} rowGap={8}>
        <Grid.Item flexDirection="column">
          <Label>ボタン前景色</Label>
          <Controller
            name="button_foreground_color"
            control={control}
            render={({ field: { onChange, value } }) => (
              <>
                <ColorPicker
                  onChange={onChange}
                  value={value}
                  disabled={!isInputAllowed('button_foreground_color')}
                />
                <ColorHex value={value} />
              </>
            )}
          />
        </Grid.Item>
        <Grid.Item nextRow flexDirection="column">
          <Label>ボタン背景色</Label>
          <Controller
            name="button_background_color"
            control={control}
            render={({ field: { onChange, value } }) => (
              <>
                <ColorPicker
                  onChange={onChange}
                  value={value}
                  disabled={!isInputAllowed('button_background_color')}
                />
                <ColorHex value={value} />
              </>
            )}
          />
        </Grid.Item>
      </Grid.Item>

      <Grid.Divider />
    </FormGrid>
  );
};

export default DeviceInfoForm;
